import api from "./api";

const setAuthToken = (token,refresh) => {

 
  if (token) {
    localStorage.setItem('token', token);
    localStorage.setItem('refresh', refresh);
    api.defaults.headers.common["Authorization"] = `${token}`;
    // api.defaults.headers.common["x-auth-token"] = token;
    
  } else {
  delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
  }
};

export default setAuthToken;
